import { useContext } from "react";
import { ItemsContext } from "../Provider";

export const useItemsContext = () => {
  const itemsContext = useContext(ItemsContext);

  if (itemsContext === null) {
    throw new Error("Context not provided");
  }

  return {
    ...itemsContext,
  };
};
